let installed = false;

const fallbackRandomUUID = (): string => `id-${Date.now()}-${Math.random().toString(16).slice(2)}`;

const randomUUIDFromGetRandomValues = (): string => {
  const bytes = new Uint8Array(16);
  (globalThis as { crypto: { getRandomValues: (buffer: Uint8Array) => Uint8Array } }).crypto.getRandomValues(bytes);

  // RFC 4122 v4 bits
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;

  const hex = Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
};

const installRandomUUID = (factory: () => string): void => {
  const runtime = globalThis as {
    crypto?: {
      randomUUID?: () => string;
      getRandomValues?: (buffer: Uint8Array) => Uint8Array;
    };
  };

  if (runtime.crypto && typeof runtime.crypto === 'object') {
    try {
      Object.defineProperty(runtime.crypto, 'randomUUID', {
        value: factory,
        writable: true,
        configurable: true,
      });
      return;
    } catch {
      try {
        runtime.crypto.randomUUID = factory;
        return;
      } catch {
        // Continue to global install attempt.
      }
    }
  }

  try {
    Object.defineProperty(globalThis, 'crypto', {
      value: { randomUUID: factory },
      writable: true,
      configurable: true,
    });
  } catch {
    // If host blocks redefining `crypto`, leave as-is.
  }
};

export function ensureCryptoRandomUUIDSupport(): void {
  if (installed) return;
  installed = true;

  const runtime = globalThis as {
    crypto?: {
      randomUUID?: () => string;
      getRandomValues?: (buffer: Uint8Array) => Uint8Array;
    };
  };

  if (typeof runtime.crypto?.randomUUID === 'function') return;

  if (typeof runtime.crypto?.getRandomValues === 'function') {
    installRandomUUID(randomUUIDFromGetRandomValues);
    return;
  }

  installRandomUUID(fallbackRandomUUID);
}
